import { CLASSIFICATION_COLORS, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { ClassificationLevel } from '@sonar-software/sonar-core';
import React from 'react';
import { Space } from 'antd';
import { When } from 'react-if';
function getLabelEntry(level) {
    return (React.createElement("div", { className: 'grouping' },
        React.createElement("span", { className: 'group-dot', style: {
                backgroundColor: `${CLASSIFICATION_COLORS[level.toLowerCase()]}19`,
                borderColor: CLASSIFICATION_COLORS[level.toLowerCase()]
            } }),
        React.createElement("span", { className: 'group-label' }, level)));
}
;
export const ClassificationLegend = ({ groupIds }) => {
    const groups = groupIds.map((entry) => entry.replace('-combo', ''));
    return (React.createElement("div", { className: 'groups' },
        React.createElement("div", { className: 'groups-header' }, COPY_SPECIFIC.CLASSIFICATION),
        React.createElement(Space, { align: 'start', size: 'small', wrap: true },
            React.createElement(When, { condition: groups.includes(ClassificationLevel.Critical.toLowerCase()) }, getLabelEntry(ClassificationLevel.Critical)),
            React.createElement(When, { condition: groups.includes(ClassificationLevel.High.toLowerCase()) }, getLabelEntry(ClassificationLevel.High)),
            React.createElement(When, { condition: groups.includes(ClassificationLevel.Medium.toLowerCase()) }, getLabelEntry(ClassificationLevel.Medium)),
            React.createElement(When, { condition: groups.includes(ClassificationLevel.Low.toLowerCase()) }, getLabelEntry(ClassificationLevel.Low)))));
};
